export const dateToUnixTimestamp = (v) => ~~(v / 1000)
